<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :width="isShow ? '30%' : '40%'"
      :show-close="false"
  >
    <div class="custom-dialog-header" slot="title">
      <span>房间管理</span>
      <i class="el-icon-close custom-close-button" @click="handleCancel"></i>
    </div>
    <el-divider class="line"/>
    <!--    密码验证-->
    <div class="passInfo" v-show="isShow">请输入密码， 继续操作</div>
    <div class="passInput" v-show="isShow">
      <div class="input-box row-center">
        <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[0] | filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[1]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[2]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[3]| filterVal }}
        </div>
        <el-input class="input-code"
                  :value="codeValue"
                  :maxlength="4"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange"
        >
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-show="isShow">
        <el-button style="width: 20%; margin-right: 30rem" @click="handleCancel" round>取 消</el-button>
        <el-button style="width: 20%" type="primary" @click="handleOk" round>确 定</el-button>
        <div style="width: 50rem; height: 80rem"></div>
    </span>
    <!--  密码验证成功-->
    <div class="status" v-show="!isShow">
      <div class="status-item" style="margin-top: 8rem">房间号：{{ roomData.roomName }}</div>
      <div class="status-item">付费模式：{{ roomData.chargingModel }}</div>
      <div class="status-item">合闸状态：{{ roomData.brakeType === 0 ? '合闸' : '未合闸' }}</div>
      <div
          style="
            font-size: 24rem;
            font-weight: 500;
            padding-top: 10rem;
            margin-bottom: 15rem"
      >绑定租户：<span v-show="!tableData.length">无关联租户</span>
      </div>
      <el-table
          v-if="!!tableData.length"
          :data="tableData"
          style="width: 100%"
          :header-cell-style='{background: "#f1f1f1"}'
      >
        <el-table-column prop="tenantName" label="租户名称" width="300"/>
        <el-table-column prop="startTime" label="绑定时间"/>
        <el-table-column
            label="操作"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-popconfirm
                title="确定解绑？"
                confirm-button-text="是"
                cancel-button-text="否"
                @confirm="handleUntie(scope.row)"
            >
              <a slot="reference" href="javascript:;">解绑</a>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-footer-info">房间仅剩一位租户时无法解绑，可前往账单管理，租户列表处销户退租。</div>
    </div>
    <div slot="footer" style="width: 100%; text-align: right" v-show="!isShow">
      <el-button style="width: 20%" type="primary" @click="handleCancel">退 出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  GET_V3_Cost_Room_Valid_Password,
  GET_V3_Cost_Room_Tenant_List,
  GET_V3_Cost_Room_Tenant_Unbind
} from '@/api/billing.js'

export default {
  name: "dialogManage",
  data() {
    return {
      dialogVisible: false,
      codeValue: '',
      inputFocus: false,
      isShow: true,
      tableData: [],
      // 房间信息
      roomData: {}
    }
  },
  filters: {
    filterVal(value) {
      if (value) {
        return '*';
      }
    }
  },
  methods: {
    // 取消
    handleCancel() {
      this.dialogVisible = false
    },

    // 密码验证
    async handlePass(val) {
      const {data} = await GET_V3_Cost_Room_Valid_Password({
        password: val
      })
      return data
    },

    // 查询租户信息
    async handleTenantList() {
      const {data} = await GET_V3_Cost_Room_Tenant_List(this.roomData.roomId)
      // console.log('查询租户信息=== ',  data)
      this.tableData = data.data
    },

    // 确定
    async handleOk() {
      if (this.codeValue.length === 0) {
        this.$message({
          message: '请输入密码！',
          type: 'warning'
        });
      } else if (this.codeValue.length < 4 && this.codeValue.length > 0) {
        this.$message({
          message: '请输入完整密码！',
          type: 'warning'
        });
      } else {
        const data = await this.handlePass(this.codeValue)
        // console.log(data)
        if (data.data == true) {
          await this.handleTenantList()
          // 正确则跳转
          this.isShow = false
        } else {
          this.codeValue = ''
          this.$message.error('密码输入错误，请重新输入！')
        }
      }
    },

    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },

    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },

    // 验证码输入框
    codeInputChange(e) {
      if (e) {
        // 判断输入内容是否为数字
        if ((/^\+?[0-9][0-9]*$/).test(e)) {
          this.codeValue = e;
        }
      } else {
        this.codeValue = '';
      }
    },

    // 解绑
    async handleUntie(data) {
      if (this.tableData.length <= 1) {
        this.$message.warning('仅剩一位租户时无法解绑,请按下方提示操作！')
        return
      } else {
        // 解绑用户, 接口调用成功后修改解绑状态为已解绑
        const res = await GET_V3_Cost_Room_Tenant_Unbind({
          id: data.id,
          roomId: this.roomData.roomId
        })
        // console.log(res)
        if (res.data.status) {
          await this.handleTenantList()
          this.$message.success(`用户 ${data.tenantName} 解绑成功！`)
        } else {
          // this.$message.error(`用户 ${data.tenantName} 解绑失败！`)
          this.$message.error(res.data.errMsg)
        }
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.codeValue = ''
        this.isShow = true
      }
    }
  }
}
</script>

<style scoped lang="less">
.custom-dialog-header {
  width: 93%;
  padding: 0;
  font-size: 24rem;
  position: absolute;
  top: 16rem;
  left: 24rem;
  //background-color: pink;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    //font-size: 24rem;

    &:hover {
      color: #409eff;
    }
  }
}

a {
  text-decoration: none;
  color: #62ace8;
}

.line {
  position: absolute;
  left: 0;
  top: 35rem;
}

.passInfo {
  text-align: center;
  color: #666;
  font-size: 18rem;
  margin-top: 50rem;
}

.passInput {
  display: flex;
  justify-content: space-around;

  .passInput-item {
    width: 12%;
    border-bottom: 1px solid #666;
    text-align: center;
  }

  /deep/ .el-input {
    width: 100%;
  }

  /deep/ .el-input__inner {
    border: none;
  }

  .input-box {
    margin-top: 10px;
    position: relative;
  }

  .input-code {
    position: absolute;
    left: 0;
    opacity: 0;
  }

  .code-item {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #999999;
    margin: 0 20px;
    display: inline-block;
  }

  .code-item-active {
    border-bottom: 1px solid #0D94FF;
    // box-sizing: border-box;
  }

  // 隐藏input
  .input-box {
    .el-input__inner {
      width: 362px;
      height: 50px;
      background-color: transparent;
      border: none;
      color: transparent;
    }
  }
}

.status {

  .status-item {
    margin-bottom: 15rem;
    font-size: 24rem;
    font-weight: 500;
    color: #333;
  }

  /deep/ .el-table th > .cell {
    color: #666 !important;
  }

  .table-footer-info {
    color: #999;
    margin-top: 20rem;
  }
}
</style>